<template>
  <div class="form-item-container">
    <div class="form-item-header">
      <v-btn class="gorate-bg cursor-default" :icon="getFormItemIconIndex" height="30" variant="text" width="30"></v-btn>
      <div class="question">
        {{ formItem.question_lang1 }}
      </div>
    </div>
    <div class="form-item-body">
      <div class="submissions-container text-h5">{{ $t('i18n.submissions') }}: {{
        getTotalResponses(formItemIndex - 1) }} </div>
      <div class="view-responses-container cursor-pointer" @click="viewSubmissionsModalIsActive = true">{{
        $t('i18n.viewSubmissions') }}</div>
    </div>
    <v-dialog v-if="formItem" v-model="viewSubmissionsModalIsActive" max-width="60%">
      <TextInputResponses
        :formName="getFormName"
        :formItemID="getFormItemID"
        :questionLang1="getFormItemQuestionLang1"
        @close-modal="closeTextInputSubmissions" />
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { FormItem } from '@/utils/DataTypes'
import { defineComponent, PropType } from 'vue'
import TextInputResponses from '@/components/modals/stats_modals/TextInputResponses.vue'

export default defineComponent({
  name: 'FaceScaleStats',
  components: {
    TextInputResponses
  },
  props: {
    stats: {
      type: Object,
      required: true,
      default: null
    },
    formItem: {
      type: Object as PropType<FormItem>,
      required: true,
      default: null
    },
    formItemIndex: {
      type: Number,
      required: true,
      default: -1
    },
    formName: {
      type: String,
      required: false,
      default: 'N/A'
    }
  },
  data () {
    return {
      viewSubmissionsModalIsActive: false
    }
  },
  methods: {
    getTotalResponses (index: number): number | string {
      return this.stats?.data?.[index]?.total_responses ?? 'N/A'
    },
    closeTextInputSubmissions () {
      this.viewSubmissionsModalIsActive = false
    }
  },
  computed: {
    getFormItemIconIndex () : string {
      return `mdi-numeric-${this.formItemIndex}`
    },
    getFormItemID () : number {
      if (this.formItem && this.formItem.id) {
        return this.formItem.id
      } else {
        return -1
      }
    },
    getFormItemQuestionLang1 () : string {
      if (this.formItem && this.formItem.question_lang1) {
        return this.formItem.question_lang1
      } else {
        return 'N/A'
      }
    },
    getFormName () : string {
      if (this.formName) {
        return this.formName
      } else {
        return ''
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/colors.scss";

.form-item-container {
  padding: 1.0em 1.5em;
  border-radius: 0px 0px 15px 15px;

  display: grid;
  grid-template-rows: auto 1fr;

  .form-item-header {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: start;

    .question {
      padding: 0 0.8em;
    }
  }

  .form-item-body {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);
    align-items: center;

    .submissions-container {
      display: grid;
      align-self: end;
      justify-content: center;
    }

    .view-responses-container {
      align-self: self-end;
      text-decoration: underline;
    }
  }
}
</style>
